import { Directive, ElementRef, NgZone, OnDestroy, AfterViewInit, inject } from '@angular/core';
import { SiSelectComponent } from '@siemens/element-ng/select';

@Directive({
    // eslint-disable-next-line @angular-eslint/directive-selector
    selector: 'si-select[closeOnScroll]'
})
export class CloseOnScrollDirective implements AfterViewInit, OnDestroy {
    private removeScrollListener?: () => void;
    private scheduled = false;

    private readonly zone = inject(NgZone);
    private readonly hostEl = inject<ElementRef<HTMLElement>>(ElementRef);
    private readonly siSelect = inject<SiSelectComponent<unknown>>(SiSelectComponent, {
        host: true
    });

    ngAfterViewInit(): void {
        this.zone.runOutsideAngular(() => {
            const onScroll = () => {
                // throttle to once per animation frame
                if (this.scheduled) return;
                this.scheduled = true;

                requestAnimationFrame(() => {
                    this.scheduled = false;
                    if (this.hostEl.nativeElement.classList.contains('open')) {
                        this.zone.run(() => this.siSelect.close());
                    }
                });
            };

            const addOpts: AddEventListenerOptions = { passive: true, capture: false };
            const removeOpts: EventListenerOptions = { capture: false };
            window.addEventListener('scroll', onScroll, addOpts);
            this.removeScrollListener = () => window.removeEventListener('scroll', onScroll, removeOpts);
        });
    }

    ngOnDestroy(): void {
        this.removeScrollListener?.();
    }
}
